import { Entity } from "../helpers/Entity"
import { SerialNumberDto } from "../serial-number/SerialNumber"
import { DisableRowReasonKey } from "./DisableReasonKeys"
import { GroupDto } from "./Group"
import Item, { ItemDto } from "./Item"
import { PricingFeeCalculationDto } from "./PricingFeeCalculation"
import { PricingTotalDto } from "./PricingTotals"
import { Reference } from "../../common/types/reference"

type CustomAttributeDefinitionAttributes = {
    label: string
}

type Metadata={
    group: GroupDto
    totals: PricingTotalDto[]
    additionalRows: PricingRowDto[]
}

type CustomAttributeDefinition = {
    id: string
    type: string
    attributes: CustomAttributeDefinitionAttributes
}

type CustomAttributeValueAttributes = {
    customAttributeDefinitionId: string
    value: string
    rowId: string
}

type CustomAttributeValue = {
    id: string
    type: string
    attributes: CustomAttributeValueAttributes
}

export type ItemMovementActions = {
    inventoryToSendMeasure: string
    inventoryToReceiveMeasure:string
    disabled: boolean
    checked: boolean
}

export type ItemMovement = PricingRowAttributes & ItemMovementActions

export type ItemMovementRow = {
    id: string
    type: string
    attributes: ItemMovement
}
export type PricingRowAttributes = {
    limit: number
    itemObject: ItemDto
    referenceRowId: string
    title: string
    invoicedMeasure: number
    additionalMeasure: string | number
    unitOfMeasure: string
    measure: string | number
    additionalUnitOfMeasure: string
    taxable: boolean
    hidePrice: boolean
    feeApplicable: PricingFeeCalculationDto
    measureEditable: boolean
    isDisabled: boolean
    disableReasonKey: DisableRowReasonKey
    itemCustomAttributeValues: CustomAttributeValue[]
    itemCustomAttributeDefinitions: CustomAttributeDefinition[]
    type: string
    billingMethod: string
    groupId: string
    currency: string
    activeTitle: string
    activeShortDescription: string
    activeLongDescription: string
    internalNotes: string
    assignedToUserId: string
    totalUnitPrice: string | number
    isTaxInclusive: boolean
    subtotalAmount: string | number
    subtotalBottomPrice: number
    subtotalBottomPriceInclusive: number
    subtotalAmountInclusive: string | number
    commitmentDuration: number
    unitPriceInclusive: string | number
    unitPrice: string | number
    calculatedUnitPrice: string | number
    discountValue: string | number
    customStatusId: string
    serialNumbers: SerialNumberDto[]
    priceLevelId:string
    metadata:Metadata
    parentId: string
    inventoryReceivedMeasure: string
    inventoryRequestedMeasure: string
    references: Reference[]
    inventorySentMeasure: string
}

export type PricingRowDto = {
    id: string
    type: string
    attributes: PricingRowAttributes
}

export default class PricingRow implements Entity {
    private dto: PricingRowDto
    private item: Item

    constructor(dto: PricingRowDto) {
        this.dto = dto
        this.item = new Item(dto.attributes.itemObject)
    }

    isLoaded() {
        return this.dto.type == "pricing-rows"
    }

    getId() {
        return this.dto.id
    }

    getLimit() {
        return this.dto.attributes.limit
    }

    getItem() {
        return this.item
    }

    getTitle() {
        return this.dto.attributes.title
    }

    getDto() {
        return this.dto
    }

    getActiveShortDescription() {
        return this.dto.attributes.activeShortDescription
    }

    getActiveTitle() {
        return this.dto.attributes.activeTitle
    }

    getActiveLongDescription() {
        return this.dto.attributes.activeLongDescription
    }

    getMetadata() {
        return this.dto.attributes.metadata ?? {}
    }
}


// WEBPACK FOOTER //
// ./src/state/pricing/PricingRow.ts